<template>
    <div class="tree-view">
        <div v-if="!Array.isArray(root)" class="toggle-button" @click="expanded = !expanded">
            <span :class="hasChildren ? '' : 'invisible'">
                 <v-icon :class="(expanded ? 'is-expanded' : '').concat(' mr-1 transition')">chevron_right</v-icon>
            </span>
            <span v-if="renderMode === 'text'"> {{ root[propertyMapper(root, 'title')] }}</span>
            <v-runtime-template v-if="renderMode === 'template'" :template="itemTemplateStr" class="d-inline-block"/>
            <component v-if="renderMode === 'component'" :is="itemComponent" :item="root" class="d-inline-block"/>
        </div>
        <ul v-if="expanded || Array.isArray(root)" :class="Array.isArray(root) ? 'list-unstyled' : ''">
            <tree-view v-for="(model, index) in children"
                       :root="model"
                       :key="index"
                       :property-mapper="propertyMapper"
                       :depth="depth + 1"
                       :item-template-str="itemTemplateStr"
                       :item-component="itemComponent"/>
        </ul>
    </div>
</template>

<script>
    import VRuntimeTemplate from 'v-runtime-template';

    export default {
        name: 'tree-view',
        components: { VRuntimeTemplate },
        props: {
            root: {
                type: [Object, Array],
                required: false,
                default: null,
            },
            depth: {
                type: Number,
                required: false,
                default: 0,
            },
            propertyMapper: {
                type: Function,
                required: false,
                default: (i, p) => p,
            },
            itemTemplateStr: {
                type: String,
                required: false,
                default: null,
            },
            itemComponent: {
                type: Object,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                expanded: false,
            };
        },
        computed: {
            item() {
                return this.root;
            },
            children() {
                let c = [];
                if (this.root) {
                    c = Array.isArray(this.root) ? this.root : this.root[this.propertyMapper(this.root, 'children')];
                }
                return c;
            },
            hasChildren() {
                return this.children && this.children.length;
            },
            renderMode() {
                let mode = 'text';
                if (this.itemComponent !== null) {
                    mode = 'component';
                } else if (this.itemTemplateStr !== null) {
                    mode = 'template';
                }
                return mode;
            },
        },
    };
</script>

<style lang="scss">
    .tree-view {
        .toggle-button {
            cursor: pointer;
        }

        .is-expanded {
            transform: rotate(90deg);
        }

        .transition {
            transition: 0.3s transform;
        }
        .invisible {
            visibility: hidden;
        }
    }
</style>